import { Trans } from "@lingui/macro";
import { IApiEpBillingBill, IApiEpBillingRecurringPayment } from "@smp/api";
import { UiBox, UiButton, UiTypography } from "@smp/ui";

import { useWindowOpener } from "@/hooks/use_window_opener";

export const Maib = ({
  bill,
  onClose,
  recurringPayment,
}: {
  bill?: IApiEpBillingBill;
  onClose: () => void;
  recurringPayment?: IApiEpBillingRecurringPayment;
}) => {
  const url = bill
    ? bill.extra.maib_transaction_approve_url
    : recurringPayment
    ? recurringPayment.confirm_url
    : undefined;

  const { isOpen, open } = useWindowOpener(
    { url },
    {
      onClose,
    },
  );

  return isOpen ? (
    <UiBox>
      <UiBox>
        <UiTypography>
          <Trans>The payment process is taking place in another window.</Trans>
        </UiTypography>
      </UiBox>
      <UiBox>
        <UiTypography>
          <Trans>Now you can close this dialog.</Trans>
        </UiTypography>
      </UiBox>
    </UiBox>
  ) : (
    <UiBox>
      <UiBox mb={2}>
        <UiTypography>
          <Trans>
            A payment invoice has been created, please proceed to payment.
          </Trans>
        </UiTypography>
      </UiBox>
      <UiBox>
        <UiButton color="primary" onClick={open} variant="contained">
          <Trans>Proceed</Trans>
        </UiButton>
      </UiBox>
    </UiBox>
  );
};
